import React from 'react';
import { useToast } from 'contexts/ToastContext';
import Toast from './Toast';
import styles from './Toast.module.css';

function ToastContainer(): JSX.Element | null {
    const { toasts, dismissToast } = useToast();

    if (toasts.length === 0) return null;

    return (
        <section className={styles.container}>
            {toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    type={toast.type}
                    message={toast.message}
                    title={toast.title}
                    dismissible={toast.dismissible}
                    onDismiss={() => dismissToast(toast.id)}
                />
            ))}
        </section>
    );
}

export default ToastContainer;
